import React, {forwardRef} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {FaTimes} from "react-icons/fa";
import {CalenderIcon} from '../helper/HwIcon';
import { flip, shift } from '@floating-ui/dom';
import moment from 'moment';
import { CloseIcon } from "../helper/HwIconExcursion";

const CustomDayComponent = ({ date, blackoutDates = [], selectDate , blackoutDays = []}) => {
  const isBlackoutDate = blackoutDates.some(blackoutDate =>
    moment(date).isSame(moment(blackoutDate), 'day')
  );
  const dayName = moment(date).format('dddd').toLowerCase()
  const isBlackOutDay = blackoutDays.map((d) => d.toLowerCase()).includes(dayName);

  const isPastDate = moment(date).isBefore(moment(), 'day');
  const isSelectedDate = selectDate && moment(date).isSame(moment(selectDate), 'day');

  if (isBlackoutDate || isBlackOutDay) {
    return (
      <div className="hw-blackout-date">
        <CloseIcon/>
      </div>
    );
  }

    return (
        <div
            style={{
                color: isPastDate ? '#ccc' : isSelectedDate ? '#fff' : '#000',
                textAlign: 'center',
            }}
        >
            {date.getDate()}
        </div>
    );
};

const HwDatePicker = forwardRef(({
    selectDate,
    onChangeFn,
    type,
    disabled,
    selectAfterShow = true,
    minDate = true,
    isError = false,
    startDate,
    endDate,
    selectsRange,
    inline,
    isClearable,
    suffix,
    excludeDates = [],
    monthsShown,
    showPreviousMonths,
    wrapperClassName,
    renderType,
    showBlackoutAsX = false,
    blackoutDates = [],
    blackoutdays = []
  }, ref) => {
    return (
      <DatePicker
        ref={ref}
        monthsShown={monthsShown}
        showPreviousMonths={showPreviousMonths}
        selected={selectDate}
        onChange={onChangeFn}
        placeholderText="Select Date"
        dateFormat="dd/MM/yyyy"
        className={"date-picker-input"}
        wrapperClassName={wrapperClassName}
        customInput={
          <CustomDateInput
            disabled={disabled}
            state={onChangeFn}
            type={type}
            selectAfterShow={selectAfterShow}
            isError={isError}
            suffix={suffix}
            monthsShown={monthsShown}
            renderType={renderType}
          />
        }
        minDate={minDate ? new Date() : ""}
        disabled={disabled}
        startDate={startDate}
        endDate={endDate}
        selectsRange={selectsRange}
        inline={inline}
        isClearable={isClearable}
        excludeDates={excludeDates}
        renderDayContents={(dayOfMonth, date) => (
          showBlackoutAsX
            ? <CustomDayComponent date={date} blackoutDates={blackoutDates} selectDate={selectDate} blackoutDays={blackoutdays}/>
            : dayOfMonth
        )}
        filterDate={showBlackoutAsX ? (date) => {
            const isBlackoutDate = blackoutDates?.some((d) => moment(date).isSame(moment(d), "day"));
            const dayName = moment(date).format("dddd").toLowerCase();
            const isBlackOutDay = blackoutdays?.map((d) => d.toLowerCase()).includes(dayName);
            return !(isBlackoutDate || isBlackOutDay);
        } : undefined}
        /*popperProps={{
            middleware: [
                flip({ fallbackPlacements: [] }),
                shift({ crossAxis: true }),
            ],
        }}*/
      />
    );
  });
const CustomDateInput = React.forwardRef(({value, onClick, state, type, disabled,selectAfterShow,isError, suffix, monthsShown,renderType}, ref) => {

    const [checkInDate, checkOutDate] = value ? value.split(' - ') : ['', ''];

    const formatDateFnForFlightSearch = (dateString) => {
        const [day, month, year] = dateString.split('/');
        let formatDate = new Date(year, month - 1, day);
        const options = {  day: '2-digit', month: 'short', year: '2-digit' };
        return new Intl.DateTimeFormat('en-GB', options).format(formatDate);
    };

    const formatExcursionDate = (input) => {
        const [day, month, year] = input.split("/");
        const date = new Date(`${year}-${month}-${day}`);
        return date.toLocaleDateString("en-GB", {
            weekday: "short",
            day: "2-digit",
            month: "short",
            year: "2-digit"
        });
    }

    let displayValue = value;
    if(renderType === 'flight'){
        if (value && value.includes(' -')) {
            const [start, end] = value.split(' -');
            if (!end.trim()) {
                displayValue = formatDateFnForFlightSearch(start);
            } else {
                displayValue = `${formatDateFnForFlightSearch(start)} - ${formatDateFnForFlightSearch(end)}`;
            }
        }else if(value){
            displayValue = formatDateFnForFlightSearch(value);
        }
    } else if (renderType === 'excursion' && value){
        displayValue = formatExcursionDate(value);
    }

    return (
        <>
{/* style={{border : isError && '1px red solid' }} */}
            <div className={`hw-input--input ${disabled ? 'disabled' : ''} ${isError ? 'hw--error-cls-date-input' : ''}`}
                 onClick={onClick}
                 ref={ref}

            >
                {(monthsShown === 2 && renderType !== 'flight' )? <div className="hw-date--calender">
                    <div className="hw-date--checkIn hw-row--gap4">
                           <CalenderIcon/>
                            <span class="hw-text14 hw-text--muted hw-line--height1">Check In</span>
                            <div className="hw-fontBold hw-blue hw-line--height1">{checkInDate || 'Select date'}</div>
                     </div>
                    <div className="hw-date--checkOut d-flex d-flex-column hw-row--gap4">
                        <span class="hw-text14 hw-text--muted hw-line--height1">Check out</span>
                        <div className="hw-fontBold hw-blue hw-line--height1">{checkOutDate || 'Select date'}</div>
                    </div>
                    {/* <div className="hw-date--nights d-flex d-flex-column hw-row--gap4" onClick={e=> e.stopPropagation()}>
                        <span class="hw-text14 hw-text--muted hw-line--height1">Total Night(s)</span>
                        <div className="hw-fontBold hw-blue hw-line--height1">{suffix}</div>
                     </div> */}
                    {
                        (checkInDate || checkOutDate) && <div className="hw-calender--removeBtn" style={{ position: "absolute", right: "0px", border: "none" }}>
                            <FaTimes
                                onClick={(event) => {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    state(null)
                                }}
                            />
                        </div>
                    }
                </div>: <>
                <CalenderIcon color={'#283D6B'}/>
                <div className="hw-blue hw-fontWeight--500 overflow-hidden">
                    {displayValue ? (
                        <div>
                            <div className="d-flex d-flex-column hw-row--gap4">
                                {selectAfterShow ? <span className="hw-text14 hw-text--muted hw-line--height1"> {type}</span> : ""}
                                <span className="hw-date--selectedDate hw-line--height1">{displayValue}</span>
                            </div>
                            <div className="hw-calender--removeBtn">
                                <FaTimes
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        event.preventDefault();
                                        state('')
                                    }}
                                />
                            </div>
                        </div>
                    ) : (
                        type
                    )}
                </div>
                </>}

                {/* <div>
                    {value ? (
                        <div>
                            <div className="d-flex d-flex-column">
                                {selectAfterShow ? <span className="hw-text14 hw-text--muted"> {type}</span> : ""}
                                <span className="">{value} {suffix}</span>
                            </div>
                            <div className="hw-calender--removeBtn">
                                <FaTimes
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        event.preventDefault();
                                        state('')
                                    }}
                                />
                            </div>
                        </div>
                    ) : (
                        type
                    )}
                </div> */}
            </div>
            {isError && <span className="hw-input--error-search left" >{isError}</span>}
        </>

    );
});

export default HwDatePicker;
